import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Ethereal%20fantasy%20game%20world%20landscape%20with%20floating%20islands%20and%20magical%20glow%2C%20warm%20amber%20and%20golden%20light%2C%20stylized%20artistic%20illustration%2C%20dreamy%20atmosphere%2C%20soft%20atmospheric%20perspective%2C%20minimalist%20composition%20with%20negative%20space%20at%20center&width=1920&height=1080&seq=hero-bg-01&orientation=landscape"
        alt="黄油网页游戏合集"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="黄油网页游戏合集 - 免费在线畅玩"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
          黄油网页游戏合集
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          免费在线畅玩精选黄油网页游戏，无需下载安装，打开浏览器即刻开启冒险。
          汇聚角色扮演、策略战棋、休闲益智等多种热门黄油网页游戏类型。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/role-playing"
            className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap text-sm"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-gamepad-line"></i>
            </div>
            开始探索
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-3 bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white font-medium rounded-full border border-white/30 transition-all duration-300 cursor-pointer whitespace-nowrap text-sm"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-information-line"></i>
            </div>
            了解更多
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-10">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">500+</div>
            <div className="text-xs text-white/60 mt-1">精选游戏</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">120万+</div>
            <div className="text-xs text-white/60 mt-1">日均玩家</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">8大</div>
            <div className="text-xs text-white/60 mt-1">游戏分类</div>
          </div>
        </div>
      </div>
    </section>
  );
}